import { WizardStateMachineInterface } from '../../../wizard/interfaces/wizard-state-machine';
import { WizardStepMeta } from '../../../wizard/interfaces/wizard-step';
import { useStateMachine } from '../../../wizard/hooks/useStateMachine';
import { CreateDestinationStepPaths } from './interface';
import { CreateDestinationSelectDestinationType } from '../CreateDestinationSelectDestinationType/CreateDestinationSelectDestinationType';
import { CreateDestinationDestinationSettings } from '../CreateDestinationDestinationSettings';
import { DestinationTypeResolver } from './destinationTypeResolver';
import {
  EntityWizardEntitySubmit,
  EntityWizardSelectEntity
} from '../../../shared/components/EntityWizardFooterComponents/EntityWizardFooterComponents';

export function useCreateDestinationStateMachine(): WizardStateMachineInterface {
  const steps: WizardStepMeta[] = [
    {
      path: CreateDestinationStepPaths.SELECT_DESTINATION_TYPE,
      component: CreateDestinationSelectDestinationType,
      footerComponent: EntityWizardSelectEntity,
      getNextStep: () => {
        return CreateDestinationStepPaths.DESTINATION_CONNECTION_SETTINGS;
      }
    },
    {
      path: CreateDestinationStepPaths.DESTINATION_CONNECTION_SETTINGS,
      component: CreateDestinationDestinationSettings,
      footerComponent: EntityWizardEntitySubmit,
      resolve: {
        destinationType: new DestinationTypeResolver()
      }
    }
  ];

  const getInitialPath = () => {
    return CreateDestinationStepPaths.SELECT_DESTINATION_TYPE;
  };

  return useStateMachine({ steps, getInitialPath });
}
